import { render, staticRenderFns } from "./PriceSection.vue?vue&type=template&id=78180514&scoped=true&"
import script from "./PriceSection.vue?vue&type=script&lang=js&"
export * from "./PriceSection.vue?vue&type=script&lang=js&"
import style0 from "./PriceSection.vue?vue&type=style&index=0&id=78180514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78180514",
  null
  
)

export default component.exports